module.exports = __webpack_public_path__ + "static/media/hering.158e16be.jpg";